<div>
  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-1">{{label}}</div>
    <span class="badge bg-warning mt-1" [title]="warning" *ngIf="warning !== undefined">!</span>
    <div class="p-1 w-75">
      <input type="range" class="w-100" [step]="step" [min]="min" [max]="max" [ngModelOptions]="{standalone: true}"
        [(ngModel)]="symbolizer[attribute]" (change)="emitChange()" />
    </div>
  </div>
</div>